// O tooltip da pílula de situação, desde as Ausências do DP (01/11/2026).
export default {
  pt: {
    'situacaoPessoa.retornoPrevisto': 'Retorno previsto em {{data}}',
  },
  en: {
    'situacaoPessoa.retornoPrevisto': 'Expected return on {{data}}',
  },
  es: {
    'situacaoPessoa.retornoPrevisto': 'Retorno previsto el {{data}}',
  },
}
